import { getRandomAlphaNumericString } from "../../../utility/Utility";

export default class Template2 {
  static getData() {
    return {
      metaData: null,
      scripts: null,
      hash: getRandomAlphaNumericString(),
      designElements: [
        {
          type: "Text",
          value:
            "ACKNOWLEDGMENT OF RECEIPT OF APPLICATION",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "bold",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 16,
            marginLeft: "auto",
            marginRight: "auto",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "center",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Date",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 10,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Address",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Dear",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 26,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "I am pleased that you have applied for our position of __________________at the University of Wisconsin - Stevens Point.  All of your application materials have arrived except (list item(s) missing).  To guarantee consideration of your application, make sure that your application is complete by ______________.  On that date the screening of applications will begin.  Approximately three weeks from that date, you should receive word about whether or not your application is still being considered.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 6,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            `As an affirmative action employer, UWSP is "required to collect and maintain data on the race, sex and ethnic identity of all applicants for employment."  Please complete the Equal Employment Opportunity survey (Form 5) on the following link, http://www.uwsp.edu/equity/Pages/form5.aspx.`,
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Additionally, under a court-approved settlement and Wisconsin Statutes, we are required to provide a list of all nominees and applicants except for those who have requested in writing that their identity not be revealed. If you do not want your name to be released, please submit your confidentiality request via the Equal Employment Opportunity survey (Form 5). Persons agreeing to be identified as final candidates will have their identity (name, address, current position) revealed.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "On behalf of my committee colleagues, we sincerely appreciate your interest in this position and thank you for your application.  Please contact me if you have any questions regarding our position.",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Sincerely,",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 18,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "NAME OF CHAIR OF SEARCH & SCREEN COMMITTEE",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 16,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 20,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        },
        {
          type: "Text",
          value:
            "Enclosure",
          style: {
            width: "fit-content",
            boxSizing: "border-box",
            fontSize: 18,
            color: "#000000",
            textAlign: "left",
            fontWeight: "normal",
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            paddingRight: 6,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: "",
            marginRight: "",
            borderRadius: 0,
            backgroundColor: "transparent",
            overflow: "hidden",
            alignSelf: "left",
            whiteSpace: "pre-wrap"
          },
        }
      ],
    };
  }
}
